import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import filter_icon from "../../images/filter-icon.svg";
import stats_img from "../../images/db-img-one.png";
import InProgress from "../../Pages/InProgress/InProgress";
import Loader from "../../Utils/Loader";
import { Typography, Box } from "@mui/material";
import stats_img_two from "../../images/db-img-second.png";
import stats_img_one from "../../images/db-img-one.png";
import sidebar from "../../Pages/Sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommunityData } from "../../Services/Community/CommunityAPI/communityApi";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { CircularProgress } from "@mui/material"; // For MUI Loader
import {getUserCount} from "../../Services/UserCounts/UserCounts";


function DashboardpageComp() {
  const { data } = useSelector((state) => state.community);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCommunityData({ page: 1, page_size: 10 }));
  }, [dispatch, 1, 10]);

  // Ensure data is an array before filtering
  //  testing data
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);
  const [totalDeactivatedUsers, setTotalDeactivatedUsers] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserCounts = async () => {
      try {
        // const response = await fetch(
        //   "https://sdeiaiml.com:9034/auth/provider/counts/"

        //       // "http://0.0.0.0:8003/auth/provider/counts/"
        // );

        const response = await getUserCount();

        // if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.data ;
     

        setTotalUsers(result.total_users);
        setTotalActiveUsers(result.active_users);
        setTotalDeactivatedUsers(result.deactivated_users);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user counts:", error);
        setLoading(false);
      }
    };

    fetchUserCounts();
  }, []);

  const chart_data = [
    { name: "Active Users", value: totalActiveUsers },
    { name: "Deactivated Users", value: totalDeactivatedUsers },
  ];

  const COLORS = ["#0057FF", "#E0E0E0"]; // Blue for active, Grey for deactivated

  if (loading)
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
        <CircularProgress color="primary"  size={60} /> {/* MUI Loader */}
      </div>
    );

  return (
    <>
      <div className="dashboard-section-main">
        <div className="dashboard-section-wrapper">
          <div className="dashboard-section-inner">
            <div className="dashboard-title-filter mb-4 d-flex align-items-center justify-content-between">
              <div className="title-db">
                {/* Good Morning, Daniel!{" "} */}
                {/* <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="30"
                    height="27"
                    x="0"
                    y="0"
                    viewBox="0 0 495.99 495.99"
                    style={{ enableBackground: "new 0 0 512 512" }}
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                        d="M177.801 289.54c16.08 0 29.16-13.08 29.16-29.16v-90.84c0-16.08-13.08-29.16-29.16-29.16s-29.17 13.08-29.17 29.16v90.84c0 16.08 13.09 29.16 29.17 29.16zM107.601 297.801c13.81 0 25.03-11.23 25.03-25.04v-74.32c0-13.8-11.22-25.03-25.03-25.03-13.8 0-25.03 11.23-25.03 25.03v74.32c0 13.81 11.23 25.04 25.03 25.04zM194.811 127.71c16.5 6.73 28.15 22.95 28.15 41.83v30.67c5.414-2.013 4.418-1.51 51.25-1.51l-47.45-177.09c-4.17-15.53-20.19-24.78-35.71-20.61-15.512 4.146-24.815 20.054-20.63 35.71zM409.501 29.76c-12.9-22.293-46.671-18.121-53.43 7.05l-43.38 161.89c20.119 0 36.031 6.571 48.73 19.27l5.13 5.13 45.86-171.2c2.02-7.53.98-15.39-2.91-22.14z"
                        fill="#f7b610"
                        opacity="1"
                      />
                      <path
                        d="M370.211 249.39c-6.911-6.911-2.854-2.856-20.11-20.1-9.4-9.41-21.91-14.59-35.21-14.59h-83.42c-4.622 0-8.51 3.707-8.51 8.52 0 27.46 22.34 49.8 49.8 49.8 44.566 0 42.486-.394 45.01 1.05 4.458 2.74 12.54 16.833 12.54 32.82 0 4.01-2.97 7.4-6.94 7.93-57.25 7.63-100.41 57-100.41 114.85 0 4.42-3.58 8-8 8s-8-3.58-8-8c0-63.26 45.36-117.62 106.72-129.47a35.206 35.206 0 0 0-4.19-11.18h-36.73c-20.05 0-38.04-9.02-50.12-23.21-4.583 37.954-51.994 53.644-78.2 25-11.438 23.304-41.348 30.294-61.87 14.45v62.47c0 70.72 57.54 128.26 128.26 128.26h57.81c70.72 0 128.25-57.54 128.25-128.26v-53.92c0-24.949-10.16-47.9-26.68-64.42z"
                        fill="#f7b610"
                        opacity="1"
                      />
                    </g>
                  </svg>
                </span> */}
              </div>
            </div>
            <div className="main-dashboard-innerwrapper">
              <div className="row">
                <div className="col-md-12 db-left-content">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                          Total Users <span>{data.count || 0}</span>
                        </div>
                        <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              {totalActiveUsers} <span>Active</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              {totalDeactivatedUsers} <span>Deactivated</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tc-img">
                        {/* <img src={stats_img_two} alt="stats-img"></img> */}
                        <ResponsiveContainer width={200} height={200}>
                          <PieChart>
                            <Pie
                              data={chart_data}
                              cx="50%"
                              cy="50%"
                              innerRadius={30}
                              outerRadius={45}
                              fill="#8884d8"
                              paddingAngle={5}
                              dataKey="value"
                              startAngle={90} // Start from the top
                              endAngle={-270} // Rotate clockwise
                            >
                              {chart_data.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={COLORS[index]}
                                />
                              ))}
                            </Pie>
                            <Tooltip />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 db-right-content">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                        </div>
                     
                        <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              450 <span>Active</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              1050 <span>Inactive</span>
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                      <div className="tc-img">
                        <img src={stats_img_one} alt="stats-img"></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 db-right-content d-none">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                          Total Home Owners <span>1000</span>
                        </div>
                        <div className="detail-btn text-start">
                          <button className="orange-filled-btn claimbtn">Details</button>
                        </div>
                    
                      </div>
                      <div className="tc-img">
                        <img src={stats_img_two} alt="stats-img"></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 db-right-content d-none">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                          Total Vendors <span>1000</span>
                        </div>
                        <div className="detail-btn text-start">
                          <button className="orange-filled-btn claimbtn">Details</button>
                        </div>
                        
                      </div>
                      <div className="tc-img">
                        <img src={stats_img_two} alt="stats-img"></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 db-right-content d-none">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                          Total Website Visitors <span>1000</span>
                        </div>
                        <div className="detail-btn text-start">
                          <button className="orange-filled-btn claimbtn">Details</button>
                        </div>
               
                      </div>
                      <div className="tc-img">
                        <img src={stats_img_two} alt="stats-img"></img>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 db-right-content d-none">
                  <div className="main-content-inner">
                    <div className="profession-block d-flex justify-content-between">
                      <div className="total-communities">
                        <div className="tc-title">
                          Total Revenue <span>1000</span>
                        </div>
                        <div className="detail-btn text-start">
                          <button className="orange-filled-btn claimbtn">Details</button>
                        </div>
                      </div>
                      <div className="tc-img">
                        <img src={stats_img_two} alt="stats-img"></img>
                      </div>
                    </div>
                  </div>
                </div> */}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "25vh",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  {/* <Loader /> */}
                  <Typography
                    variant="h5"
                    sx={{
                      marginTop: "20px",
                      color: "#333",
                    }}
                  >
                    {/* This feature is in progress. Please check back later. */}
                  </Typography>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardpageComp;
